import { NgModule } from '@angular/core';
import { TooltipDirective } from './tooltip/tooltip.directive';
import { NumberOnlyDirective } from './input/number-only.directive';
import { TextWithoutNumbersDirective } from './input/text-without-numbers.directive';
import { CopyClipboardDirective } from './copy-clipboard.directive';
import { SkeletonLoaderDirective } from './skeleton-loader/skeleton-loader.directive';
import { NlfButtonDirective } from './nlf-button/nlf-button.directive';

@NgModule({
	declarations: [TooltipDirective, NumberOnlyDirective, TextWithoutNumbersDirective, CopyClipboardDirective, SkeletonLoaderDirective, NlfButtonDirective],
	imports: [],
	exports: [TooltipDirective, NumberOnlyDirective, TextWithoutNumbersDirective, CopyClipboardDirective, SkeletonLoaderDirective, NlfButtonDirective]
})
export class DirectivesModule { }
